<template>
  <div>
    <EmailEditor
        ref="emailEditor"
        style="height: 600px;"
        v-on:load="editorLoaded"
        :options="{
        specialLinks: [
          {
            name: 'Website',
            href: siteUrl,
            target: '_self',
          },
          {
            name: 'Unsubscribe',
            href: siteUrl + '/unsubscribe',
            target: '_self',
          },
        ]
    }"
    />
    <b-button v-on:click="saveDesign">
      Save
    </b-button>
  </div>
</template>

<script>
import {EmailEditor} from 'vue-email-editor'
import htmlTemplate from '../../../config/MailTemplateConfig.json'

export default {
  name: 'MailEditor',
  components: {
    EmailEditor,
  },
  data() {
    return {
      template: htmlTemplate,
      siteUrl: process.env.VUE_APP_WEBSITE_URL,
    }
  },
  methods: {
    editorLoaded() {
      this.$refs.emailEditor.editor.loadDesign(this.template);
    },
    saveDesign(){
      this.$refs.emailEditor.editor.exportHtml(
        (data)  =>  {
          this.$emit('save', data.html);
        }
      );
    },
  },
}
</script>
